import { Component, Type, Input } from '@angular/core';
import { DataItem } from '../../models/data-item';
import { FieldsetModule } from 'primeng/fieldset';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';


@Component({
  selector: 'app-data-box',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FieldsetModule
  ],
  templateUrl: './data-box.component.html',
  styleUrl: './data-box.component.scss'
})
export class DataBoxComponent {

  ref: DynamicDialogRef | undefined;

  @Input() headerTitle?: string;
  @Input() footer?: string;
  @Input() dataBoxItems: DataItem[] | undefined;
  @Input() helpComponent?: Type<any>; 

  constructor(public dialogService: DialogService) {}

  onHelpClicked(): void {
    if(this.helpComponent) {
      this.ref = this.dialogService.open(this.helpComponent, {
        header: this.headerTitle,
        width: "50vw",
        modal: true,
        dismissableMask: true,
        breakpoints: {
          '500px': '98vw'
        },
        contentStyle: { 'background-color': 'var(--surface-0)'},
        footer: this.footer
      });
    }
  }
}
